export default __webpack_public_path__ + "static/media/0302-1349x669.b5d70693.jpg";